import { Box } from '@/components/Box/Box';
import { ModalWindow } from '@/components/ModalWindow/ModalWindow';
import { useTimer } from '@/hooks/useTimer';
import WarningSecondaryIcon from '@/images/WarningSecondaryIcon.svg?react';
import { Typography } from '@/components/Typography/Typography';
import { Button } from '@/components/Button/Button';
import { useLogout } from '@/bundle/shared/hooks/useLogout';
import { COLORS } from '@/styles/colors';
import { ButtonGroup } from '@/components/Button/ButtonGroup/ButtonGroup';

const SECONDS_BEFORE_LOGOUT = 60;

type BannerLogoutModalType = {
  onClose: () => void;
};

export const BannerLogoutModal = ({ onClose }: BannerLogoutModalType) => {
  const { mutate, isPending } = useLogout();

  const logout = () => {
    mutate();
  };

  const { seconds } = useTimer(SECONDS_BEFORE_LOGOUT, logout);

  return (
    <ModalWindow isOpen={true} width='510px'>
      <Box display='flex' flexDirection='column' alignItems='center' justifyContent='center'>
        <Box marginBottom='20px'>
          <WarningSecondaryIcon />
        </Box>
        <Typography variant='headline4' fontWeight='semibold' marginBottom='12px'>
          Organization Created Successfully
        </Typography>
        <Typography marginBottom='12px' textAlign='center'>
          To complete your Master Admin account setup and enhance its security, you’ll be asked to set a password during
          your first login.
        </Typography>
        <Typography marginBottom='28px' textAlign='center'>
          For security reasons, you will be automatically logged out in{' '}
          <Typography as='span' fontWeight='semibold' color={COLORS.green[500]}>
            {seconds}
          </Typography>{' '}
          seconds. You can also choose to log out now and finish the setup from the login page.
        </Typography>
      </Box>

      <ButtonGroup>
        <Button variant='secondary' onClick={onClose}>
          Stay Logged In
        </Button>
        <Button onClick={logout} disabled={isPending}>
          Log Out Now
        </Button>
      </ButtonGroup>
    </ModalWindow>
  );
};
